/* portance pimaCotton Tee – Bild-Slider
   Scroll-Snap-Track mit Pfeilen, Dots, Swipe und optionalem Autoplay. */
(function () {
  if (customElements.get('portance-tee-slider')) return;

  class PortanceTeeSlider extends HTMLElement {
    connectedCallback() {
      // Wird das Element im Theme-Editor verschoben, läuft connectedCallback
      // erneut – dann nur Autoplay wieder starten, nicht neu verdrahten.
      if (this.initialized) {
        // Position wiederherstellen, Listener bleiben am Element hängen.
        window.requestAnimationFrame(() => this.goTo(this.index, false, 'auto'));
        this.startAutoplay();
        return;
      }
      this.initialized = true;

      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.index = 0;

      if (!this.track || this.slides.length < 2) return;

      this.onPrev = () => this.goTo(this.index - 1, true);
      this.onNext = () => this.goTo(this.index + 1, true);
      this.onScroll = () => {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => this.syncFromScroll(), 80);
      };
      this.onKeydown = (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.onPrev();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.onNext();
        }
      };

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('keydown', this.onKeydown);

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.goTo(i, true));
      });

      this.setupAutoplay();
      this.update();
    }

    disconnectedCallback() {
      // Nur Timer stoppen: die Listener hängen am Element selbst bzw. an
      // seinen Kindern und bleiben nach einem Reconnect gültig.
      this.stopAutoplay();
      window.clearTimeout(this.scrollTimer);
    }

    goTo(index, fromUser, behavior) {
      const total = this.slides.length;
      this.index = ((index % total) + total) % total;

      const target = this.slides[this.index];
      this.track.scrollTo({
        left: target.offsetLeft - this.track.offsetLeft,
        behavior: behavior || (this.prefersReducedMotion() ? 'auto' : 'smooth')
      });

      this.update();
      if (fromUser) this.restartAutoplay();
    }

    syncFromScroll() {
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      let closest = 0;
      let smallest = Infinity;

      this.slides.forEach((slide, i) => {
        const slideCenter = slide.offsetLeft - this.track.offsetLeft + slide.offsetWidth / 2;
        const distance = Math.abs(slideCenter - center);
        if (distance < smallest) {
          smallest = distance;
          closest = i;
        }
      });

      if (closest !== this.index) {
        this.index = closest;
        this.update();
      }
    }

    update() {
      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    setupAutoplay() {
      const delay = parseInt(this.dataset.autoplay || '', 10);
      if (!delay || this.prefersReducedMotion()) return;

      this.autoplayDelay = delay;
      this.startAutoplay();

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
    }

    startAutoplay() {
      if (!this.autoplayDelay || this.autoplayTimer) return;
      this.autoplayTimer = window.setInterval(() => this.goTo(this.index + 1, false), this.autoplayDelay);
    }

    stopAutoplay() {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
  }

  customElements.define('portance-tee-slider', PortanceTeeSlider);
})();
